import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f3c0d0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-3 py-3 text-gray-800 dark:text-dark-text bg-white dark:bg-dark-800" }
const _hoisted_2 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WarningText = _resolveComponent("WarningText")!
  const _component_ReviewDetailViewer = _resolveComponent("ReviewDetailViewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isAiReview(_ctx.entryId).value)
      ? (_openBlock(), _createBlock(_component_WarningText, {
          key: 0,
          text: _ctx.AIWARNTEXT
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ReviewDetailViewer, {
        entryId: _ctx.entryId,
        entryType: _ctx.entryType,
        index: _ctx.index
      }, null, 8, ["entryId", "entryType", "index"])
    ])
  ]))
}